import { __read, __spread } from "tslib";
import { find, cloneDeep, remove, forEach } from 'lodash-es';
import { HOTSPOT_DELETED } from './constants/hotspotStatus';
var cloneProject = function (fn) { return function (origProjectConfig) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (!origProjectConfig) {
        throw new Error('origProjectConfig is required');
    }
    var newConfig = cloneDeep(origProjectConfig);
    fn.apply(void 0, __spread([newConfig], args));
    return newConfig;
}; };
var updateHotspot = cloneProject(function (origProjectConfig, hotspot) {
    var imageID = hotspot.img_owner_fk;
    var image = find(origProjectConfig.images, function (_a) {
        var id = _a.id;
        return id === imageID;
    });
    if (image) {
        var predicate = function (_a) {
            var id = _a.id;
            return id === hotspot.id;
        };
        if (hotspot.status === HOTSPOT_DELETED) {
            remove(image.hotspots, predicate);
        }
        else {
            addOrReplace(image.hotspots, hotspot, predicate);
        }
    }
});
var addHotspots = cloneProject(function (origProjectConfig, hotspots) {
    var imageMap = {};
    forEach(origProjectConfig.images, function (image) {
        imageMap[image.id] = image;
        if (!image.hotspots) {
            // eslint-disable-next-line no-param-reassign
            image.hotspots = [];
        }
    });
    hotspots.forEach(function (hotspot) {
        var image = imageMap[hotspot.img_owner_fk];
        // Not sure why but we've started to see hotspots that belong to screens
        // that don't exist in the project. While we figure that out, we defend
        // against it here otherwise prototypes won't load at all
        if (image) {
            image.hotspots.push(hotspot);
        }
    });
});
function addOrReplace(array, element, predicate) {
    /* eslint-disable no-param-reassign */
    for (var i = 0; i < array.length; i += 1) {
        if (predicate(array[i])) {
            array[i] = element;
            return;
        }
    }
    array.push(element);
}
export { updateHotspot, addHotspots };
